<ul class="user-profile-menu list-group">
  <li class="list-group-item menu-title">EINSTELLUNGEN</li>
  <li class="list-group-item" *ngIf="!!authService.permissions.WHITELABEL_DESIGNER" (click)="goTo(['design-wizard'])">
    <span class="sub-menu-icon"> <app-svg-icon src="./assets/icons/swatchbook-solid.svg"></app-svg-icon></span>
    <a>
      <span class="sub-menu-text">{{ 'module.layout.header.systemSettingsText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" *ngIf="!!authService.permissions.DESIGNER" (click)="goTo(['designer'])">
    <span class="sub-menu-icon"> <app-svg-icon src="./assets/icons/check-double-solid.svg"></app-svg-icon></span>
    <a>
      <span class="sub-menu-text">{{ 'module.layout.header.webAppConfigurationText' | translate }}</span>
    </a>
  </li>
</ul>
